// Client V2 common imports
const { useExperiment } = require('client-v2/common/containers/rollouts')
const useMatchMedia = require('client-v2/common/hooks/match-media')

function useHasSidebar() {
  let hasSidebar = useExperiment('*web_sidebar') === 'enabled'
  const isWindowTooNarrow = useMatchMedia('(max-width: 1200px)')
  if (isWindowTooNarrow) {
    hasSidebar = false
  }
  return hasSidebar
}

module.exports = {
  useHasSidebar
}
